export const f_rules = {
    mandatory: v => (v === 0 || !!v) || 'Campo obbligatorio',
    piva: v => ((v || '').length == 0 || /^[0-9]{11}$/.test(v || '')) || 'pIVA deve contenere 11 cifre',
    fiscal_code: v => ((v || '').length == 0 || /^[a-zA-Z]{6}[0-9]{2}[abcdehlmprstABCDEHLMPRST]{1}[0-9]{2}([a-zA-Z]{1}[0-9]{3})[a-zA-Z]{1}$/.test(v || '')) || /^[0-9]{11}$/.test(v || '') || 'Codice fiscale non valido',
    nameRules: (v, len) => ((v || '').length == 0 || (v || '').length >= (len || 3)) || 'Minimo ' + (len || 3) + ' caratteri',
    arrayRules: v => (!!v && v.length > 0) || 'Campo obbligatorio',
    emailRules: v => ((v || '').length == 0 || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v || '')) || 'E-mail non valida',
    negativeNumberRules: v => ((v || '').length == 0 || /^-?\d*\,?\d+(?:[E|e][\+\-]?\d+)?$/.test(v + "" || '')) || 'Non è un numero',
    minRules: (v, min) => (!isNaN(parseFloat(v)) && parseFloat(v) >= min) || `Il valore deve essere maggiore di ${min}`,
    maxRules: (v, max) => (!isNaN(parseFloat(v)) && parseFloat(v) <= max) || `Il valore deve essere minore di ${max}`,
    numberRules: v => ((v || '').length == 0 || /^\d*\,?\d+(?:[E|e][\+\-]?\d+)?$/.test(v + "" || '')) || 'Non è un numero',
    mandatoryReportRules: (rep, types, v) => contains_report(v, rep, types),
    mandatoryNullReportRules: (v, rep, types) => null_contains_report(v, rep, types)
        // exp  /^\d*\,?\d+(?:[E|e][\+\-]?\d+)?$/
}

export const getCertificatePath = () => {
    if (process.env.VUE_APP_CERTIFICATE_HOST) {
        return process.env.VUE_APP_CERTIFICATE_HOST
    } else {
        return '/mastercalFiles'
    }
}

function contains_report(v, rep_type, types) {
    console.log("$$ contains report", rep_type, types)
    if (types && types.length > 0 && types.includes(rep_type)) {
        console.log("$$ entrato, valore letto", v)
        if (!!v && v != 0) {
            console.log("$$ valore accettato", v)
            return true
        } 
        return 'Campo obbligatorio'
        
    }
    return true
}

function null_contains_report(v, rep_type, types) {
    if (types.includes(rep_type)) {
        if (!!v) {
            return true
        }
        return 'Campo obbligatorio'
    }
    return true
}

export const formatDatefromTS = (timestamp) => {
    if (!timestamp) return ""
    let d = new Date(timestamp)
    return `${(d.getDate()+'').padStart(2, '0')}/${(d.getMonth() + 1 + '').padStart(2, '0')}/${d.getFullYear()}`
}

export const formatDate = (date) => {
    if (!date) return null
    const [year, month, day] = date.split('-')
    return `${day}/${month}/${year}`
}
export const getTimestamp = (date_str, separator) => {
    const [year, month, day] = date_str.split(separator || '-')
    let c_date = new Date(Date.UTC(year, (month - 1), day))
    return c_date.getTime()
}

export const getISOString = (date_str, separator) => {
    const [year, month, day] = date_str.split(separator || '-')
    let c_date = new Date(Date.UTC(year, (month - 1), day))
    return c_date.toISOString().substr(0, 10)
}


export const parseDate = (date, separator) => {
    if (!date) return null
    const [month, day, year] = date.split(separator || '-')
    return `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${year}`
}

//import { config_default_data } from './common'
import { differenceInMonths, differenceInDays, addMonths, addDays } from 'date-fns'

export const getExpStatus = (threshold, from, to) => {
    let res = null
    switch (threshold.type) {
        case 'month':
            res = differenceInMonths(to, from)
            break;
        case 'day':
            res = differenceInDays(to, from)
            break;
    }
    //console.log('GETEXPSTATUS res', res)
    if (res < threshold.alert) {
        return 'alert'
    } else if (res < threshold.warning && res >= threshold.alert) {
        return 'warning'
    } else {
        return 'ready'
    }
}

export const getExpStatusDatetime = (threshold) => {
    let now = new Date()
    let d_alert = null
    let d_warning = null
    switch (threshold.type) {
        case 'month':
            d_alert = addMonths(now, threshold.alert)
            d_warning = addMonths(now, threshold.warning)
            break;
        case 'day':
            d_alert = addDays(now, threshold.alert)
            d_warning = addDays(now, threshold.warning)
            break;
    }
    return {
        'ready': { from: d_warning.getTime() },
        'warning': { to: d_warning.getTime(), from: d_alert.getTime() },
        'alert': { to: d_alert.getTime() }
    }

}


export const checkMasterCategoryMatch = (master, category) => {
    let mismatch = []
    for (let block of master.blocks) {
        let blk_id = block._id
        if (category[master.op_type][blk_id] && category[master.op_type][blk_id].cat_type == "single" && !category[master.op_type][blk_id].calc_value && category[master.op_type][blk_id].value == null) {
            mismatch.push({ _id: blk_id, label: category[master.op_type][blk_id].label, reason: 'value' })
        } else if (category[master.op_type][blk_id] && category[master.op_type][blk_id].cat_type == "multiple" && !category[master.op_type][blk_id].calc_value) {
            let found = false
            for (let trial of category[master.op_type][blk_id].trials) {
                if (trial.values_nr == block.conf.min_readings) {
                    found = true
                    break
                }
            }
            if (!found) {
                mismatch.push({ _id: blk_id, label: category[master.op_type][blk_id].label, reason: 'trial_nr', nr_value: block.conf.min_readings })
            }
        }
    }
    return mismatch
}

export const getDefaultOrderNr = (user) => {
    /*if (!config_default_data.operation.set_default) {
        return ''
    }
    let order_nr = config_default_data.operation.order_nr
    let d = new Date()
    order_nr = order_nr.replace('$date', `${d.getFullYear()}${(d.getMonth() + 1 + '').padStart(2, '0')}${(d.getDate()+'').padStart(2, '0')}`)
    order_nr = order_nr.replace('$user', user.code)
    return order_nr*/
}

export const getObjStatus = (threshold, obj, data) => {
    //console.log('***** getObjStatus', obj._id)
    let status = ''
    switch (obj.doc_type) {
        case 'instrument':
            if (data.expire_status) {
                let from = new Date()
                if (obj.primary) {
                    let to = new Date(obj.primary_data.expire)
                    status = { 'instrument': getExpStatus(threshold, from, to) }
                } else {
                    status = {
                        'instrument': 'no_reports'
                    }
                    for (let report of data.allowed_report) {
                        let next_op = obj.metrological_info[report].next_operation
                        if (next_op) {
                            status[report] = getExpStatus(threshold, from, new Date(next_op))
                            switch (status[report]) {
                                case 'alert':
                                    status.instrument = 'alert'
                                    break
                                case 'warning':
                                    if (status.instrument && status.instrument != 'alert') {
                                        status.instrument = 'warning'
                                    }
                                    break
                                case 'ready':
                                    if (status.instrument && status.instrument != 'alert' && status.instrument != 'warning') {
                                        status.instrument = 'ready'
                                    }
                                    break
                            }
                        }
                    }
                }
                //console.log('***** status', status)

            } else {
                status = obj.complete[data.op_type] ? 'ok' : 'ko'
            }
            break;
        case 'client':
            status = obj.complete ? 'ok' : 'ko'
            break;
        case 'location':
            status = obj.complete ? 'ok' : 'ko'
            break
        case 'operation':
            status = obj.status
            break
        case 'report':
            switch (obj.status) {
                case 'failed':
                    status = 'failed'
                    break
                case 'deleted':
                    status = 'deleted'
                    break
                case 'ready':
                    status = 'picture_as_pdf'
                    break
                case 'ready_failed':
                    status = 'picture_as_pdf'
                    break
                case 'completed':
                    status = 'waiting_review'
                    break
                case 'reviewed':
                    status = 'reviewed'
                    break
                case 'signed':
                    status = 'signed'
                    break
                case 'revising':
                    status = 'revising'
                    break
                default:
                    status = 'doing'
            }
            break
        default:
            break
    }
    return status
}

export const uoms_conversion = {
    // TODO update this table to manage dosers and probes => liters and UHR%
    // value is  x : y * K   i.e: mg = g * 0.001 
    'mg': {
        "mg": 1,
        "g": 0.001,
        "kg": 0.000001
    },
    'g': {
        "mg": 1000,
        "g": 1,
        "kg": 0.001
    },
    'kg': {
        "mg": 1000000,
        "g": 1000,
        "kg": 1
    }
}

import Big from "big.js"
export const convertPrimaryWeights = (weights, primaries, instrument_uom, uom_conversion = true) => {
    let weightItems = []
    if (weights) {
        weights.forEach(item => {
            let primary = primaries.find(element => {
                return element._id == item.weightSet
            })
            if (primary) {
                let weight = primary.primary_data.data.values.find(element => {
                    return element._id == item.mass
                })
                if (weight) {
                    if (primary.family == "pesiera" && uom_conversion) {
                        let conv_factor = uoms_conversion[primary.primary_data.data.uom][instrument_uom]
                        // console.log("$$ found conv factor", conv_factor)
                        weight.name = Big(weight.name).times(conv_factor).toString()
                        weight.conv = Big(weight.conv).times(conv_factor).toString()
                        weight.uncertain_ext = Big(weight.uncertain_ext).times(conv_factor).toString()
                    }
                    weightItems.push(weight)
                }
            }
        })
    }
    return weightItems
}

export const createWeightsDict = (primaries) => {
    // console.log("primaries ", primaries)
    let dict = {
    }
    for (let primary of primaries) {
        if (primary.primary_data.complete) {
            for (let mass of primary.primary_data.data.values) {
                if (!(mass.name in dict)) {
                    dict[mass.name] = []
                }
                dict[mass.name].push(mass)
            }
        }
    }
    for (const [key, value] of Object.entries(dict)) {
        dict[key] = value.sort(function compare(a, b) {
            if (a._id < b._id) {
                return -1
            }
            if (a._id > b._id) {
                return 1
            }
            return 0
        })
    }
    // console.log("dizionario completo", dict)
    return dict
}




const countDecimals = (value) => {
    if (value != null && value != undefined && value != "") {
        let bVal = Big(value)
        if (bVal.eq(bVal.toFixed(0))) {
            return 0;
        }
        let split = value.toString().split(".")
        if (split.length > 1) {
            return split[1].length
        }
    }
    return 0
}

export const createAlgoInputs = (currDict) => {
    let arr = []
    let max_decimals = 0
    for(const [key, value] of Object.entries(currDict)){
        let decimals = countDecimals(key)
        if(decimals > max_decimals){
            max_decimals = decimals
        }
        arr.push([key, value.length])
    }
    if(max_decimals > 0){
        for(let i = 0; i<arr.length; i++){
            arr[i][0] = arr[i][0] * Math.pow(10, max_decimals)
        }
    }
    let arr2 = arr.map(item => {
        return [parseInt(item[0]), item[1]]
    })

    arr2 = _.sortBy(arr2, function(a){
        return a[0]
    })
    return {arrVals: arr2, decimals: max_decimals}
}
const count_entries = (sol, decimals) => {
    if(sol && sol.length > 0 && sol[0] != -1){
        let dizionario = {}
        for(let k of sol){
            let i = k * Math.pow(10, -decimals)
            if(i < 1){
                i = i.toFixed(decimals)
            }
            dizionario[i] = (dizionario[i] ? dizionario[i] : 0) + 1
        }
        return dizionario
    } else {
        return null
    }
}
//processAlgoOutput works with get_opt (CURRENT SOLUTION)
export const processAlgoOutput = (sol, wDict, decimals) => {
    let d_entries = count_entries(sol, decimals)
    if(d_entries){
        let arr = []
        for(let k of Object.keys(d_entries)){
            for(let i = 0; i<d_entries[k]; i++){
                let item = wDict[k][i]
                arr.push({weightSet: item.instrument, mass: item._id })
            }
        }
        return arr
    } else {
        return []
    }
}

//processAlgoResults works with algo2 DEPRECATED
export const processAlgoResults = (items) => {
    if (items && items.length > 0) {
        return items.map(a => {
            return { weightSet: a.instrument, mass: a._id }
        })
    } else {
        return []
    }
}


export const changeUom = (weights, instrument_uom) => {
    for (let elem of weights) {
        let weightset_uom = elem.primary_data.data.uom
        if (weightset_uom && weightset_uom !== instrument_uom) {
            let conv_factor = uoms_conversion[weightset_uom][instrument_uom]
            for (let weight of elem.primary_data.data.values) {
                weight.name = Big(weight.name).times(conv_factor).toString()
                weight.conv = Big(weight.conv).times(conv_factor).toString()
                weight.uncertain_ext = Big(weight.uncertain_ext).times(conv_factor).toString()
            }
        }
    }
    return weights
}

export const modifyWeightSet = (weights) => {
    for (let weightSet of weights) {
        for (let mass of weightSet.primary_data.data.values) {
            mass.instrument = weightSet._id
        }
    }
}